<div class="inquiry-topic-button d-flex justify-content-center p-4">
  <div class="text">
    <ng-content />
  </div>
  <cov-icon class="icon" [iconName]="IconName.CHEVRON_RIGHT" />
</div>
